import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { clone } from 'lodash';

import { bemClasses } from '../../utils/bem';

import './styles.scss';

import Hoverable from '../hoverable';

class Button extends Component {
  ALLOWED_MODIFIERS = [
    'green',
    'blue',
    'red',
    'orange',
    'yellow',
    'grey',
    'disabled',
    'static',
    'activeGreen',
    'fullWidth',
    'grow',
    'small',
    'narrow',
    'large',
    'attached',
    'leftIcon',
    'plusIcon',
    'tickIcon',
    'searchIcon',
    'ouroborosIcon',
    'openLockIcon',
    'closedLockIcon',
    'downArrowIcon',
    'noText',
    'upArrowIcon',
    'crossIcon',
  ];

  componentClassNames = () => {
    let options = clone(this.props);
    if (!this.props.text) {
      options['noText'] = true;
    }

    return bemClasses('button', this.ALLOWED_MODIFIERS, options);
  };

  onClick = () => {
    if (this.props.onClick) {
      this.props.onClick(this.props.onClickObject);
    }
  };

  renderButton = () => {
    if (this.props.href) {
      return (
        <a
          href={this.props.href}
          className={this.componentClassNames()}
          target={'_blank'}
          rel={'noopener noreferrer'}
        >
          {this.props.text}
        </a>
      );
    }

    if (this.props.to) {
      return (
        <Link to={this.props.to} className={this.componentClassNames()}>
          {this.props.text}
        </Link>
      );
    }

    return (
      <button
        type={this.props.type}
        onClick={this.onClick}
        className={this.componentClassNames()}
      >
        {this.props.text}
      </button>
    );
  };

  render = () => {
    if (this.props.hover) {
      return (
        <Hoverable text={this.props.hover}>{this.renderButton()}</Hoverable>
      );
    }

    return this.renderButton();
  };
}

export default Button;
